import { CapacityIcon } from "@assets/icons";
import { Particles } from "@components/particles";
import { useScreenSize } from "@utils/hooks/use-screen-size";
import { version } from "../../../package.json";

type AuthLayoutProps = {
  children: React.ReactNode;
};

export const AuthLayout = ({
  children,
}: AuthLayoutProps): React.ReactElement => {
  const { screenSize } = useScreenSize();

  return (
    <div className="fixed h-screen w-screen overflow-hidden bg-black">
      <Particles className="fixed -z-10 h-screen w-screen" />
      <div className="absolute flex h-screen w-screen flex-col  items-baseline justify-between overflow-hidden px-6 py-10 lg:px-14">
        <div className="w-full">
          <h1 className=" mx-auto text-center text-2xl font-medium text-white md:w-full md:text-3.5xl lg:text-left xl:pt-0 xl:text-left xl:text-4xl">
            Capacity for Shippers
          </h1>
          <h2 className="mx-auto mt-4 w-max skew-x-[-12deg] transform bg-blue-400 px-2 text-4xl font-bold leading-none text-white lg:ml-0">
            NEW FEATURE
          </h2>
        </div>
        <div
          className={` flex w-full flex-wrap items-center ${
            screenSize.height > 800 && screenSize.width > 1024 ? "-mt-20" : ""
          }`}
        >
          <div className="order-1 w-full lg:order-2 lg:w-1/2">{children}</div>
          <div className=" order-2 mt-8  w-full  lg:order-1 lg:mt-0 lg:w-1/2">
            <p className="mx-auto w-[285px] text-base font-bold text-white md:w-[540px] md:text-[25px]  lg:ml-0 lg:w-[400px] xl:w-[520px]">
              Discover the Game Changing Power of CAPACITY FOR SHIPPERS. Now,
              Shippers can rely Edge’s proprietary technology to source the
              proper carrier partners and lanes
            </p>
          </div>
        </div>
        <footer className="w-full">
          <div className="flex w-full justify-center xl:justify-start">
            <CapacityIcon className="w-[160px] md:w-[200px]  xl:w-[370px]" />
          </div>
          <p className="col-span-2 hidden text-center text-white xl:block">
            Edge Logistics LLC, 2021 Platform Version v{version}
          </p>
        </footer>
      </div>
    </div>
  );
};
